import { ADDRESS_FIELD_MAX_LENGTHS_BY_KEY, AddressFieldKey } from './address-field-limits.constants'

export const getAddressFieldMaxLength = (fieldName?: string | null): number | undefined => {
  if (!fieldName) return undefined
  return ADDRESS_FIELD_MAX_LENGTHS_BY_KEY[fieldName as AddressFieldKey]
}
